const themes = {
	// Žena skin
	zena: {
		title: `
			color: #8f3d7e;
			border-bottom: 1px solid currentColor;
			font-size: 20px;
			font-weight: 600;
			text-transform: uppercase;
		`,
		form: `
			background: #e5c2de;
			border-top: 10px solid currentColor;
			color: #8f3d7e;
			font-family: OpenSans, sans-serif;
			font-size: 16px;
		`,
		formInner: `
			@media (min-width: 480px) {
				padding: 0 1em;
			}
		`,
		formElement: `
			display: flex;

			@media (max-width: 480px) {
				display: block;
			}
		`,
		label: `
			flex: 1 1 60%;
			font-weight: 600;
			border-bottom: 1px dashed #ccc;

			@media (max-width: 480px) {
				margin-bottom: 0.5em;
			}
		`,
		input: `
			border-radius: 3px;
			font-family: inherit;
		`,
		inputWrap: `
			flex: 1 1 40%;
		`,
		radioWrap: `
			flex: 0 0 100%;
			margin-top: 1em;
		`,
		button: `
			background: #8f3d7e;
			border: 1px solid #8f3d7e;
			color: #fff;
			width: 200px;
		`,
		info: `
			font-size: 14px;
			font-style: italic;
			line-height: normal;
		`,
	},
	// 2019 redesign
	aktualne: {
		title: `
			font-size: 1.5em;
			font-weight: 700;
		`,
		form: `
			background: #f4f7fd;
			color: #05171f;
			font-family: Lora, serif;
			font-size: 14px;
		`,
		formInner: `
			@media (min-width: 480px) {
				padding: 0 2em;
			}
		`,
		formElement: ``,
		button: `
			background: #1b68bf;
			border: none;
			border-radius: 3px;
			box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
			color: #fff;
			font-family: Barlow, sans-serif;
			font-size: 12px;
			font-weight: 700;
			padding: 1em 2em;
			text-transform: uppercase;
		`,
		label: `
			display: block;
			font-weight: 700;
		`,
		radioLabel: `
			font-family: Barlow, sans-serif;
			font-style: italic;
		`,
		input: `
			background-color: transparent;
			border-color: #d2d9de;
			font-family: Barlow, sans-serif;
		`,
		column: `
			box-shadow: 0 0 9px rgba(0, 0, 0, 0.25);
		`,
		currency: `
			padding: 10px;
		`,
		tabs: `
			border-bottom: 1px solid #1b68bf;
		`,
		tab: `
			background: #1b68bf;
			color: #fff;
			border-color: #1b68bf;
			font-family: Barlow, sans-serif;
			font-size: 14px;
			transform: translateY(1px);
		`,
		tabActive: `
			background: #f4f7fd;
			color: inherit;
		`,
		info: `
			line-height: 1.8;
		`,
	},
};

// Back-compatible options
themes.blue = themes.aktualne;
themes.purple = themes.aktualne;
themes.cyan = themes.aktualne;
themes.pink = themes.zena;

export default themes;
